import { classes } from '@dittolive/anvil'
import React, { forwardRef } from 'react'

const DataBridgeSectionRowContainer = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={classes(
        'flex h-20 w-full items-center justify-between px-4',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})
DataBridgeSectionRowContainer.displayName = 'DataBridgeSectionRowContainer'

export default DataBridgeSectionRowContainer
